import React from 'react';
import { UpcommingPayments } from '../../logic/components';

const UpcomingPaymentsRoute = () => {
  return (
    <div className="container">
      <UpcommingPayments />
    </div>
  );
};

export default React.memo(UpcomingPaymentsRoute);
